import React from "react";

interface Props {
  className?: string;
}

const CircleRingsIcon: React.FC<Props> = ({className}) => (
  <svg
    className={className}
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M28 16.0007C28 9.37323 22.6275 4.00065 16 4.00065C9.37262 4.00065 4.00004 9.37323 4.00004 16.0007C4.00004 22.6281 9.37262 28.0007 16 28.0007C22.6275 28.0007 28 22.6281 28 16.0007ZM30.6667 16.0007C30.6667 24.1008 24.1002 30.6673 16 30.6673C7.89986 30.6673 1.33337 24.1008 1.33337 16.0007C1.33337 7.90047 7.89986 1.33398 16 1.33398C24.1002 1.33398 30.6667 7.90047 30.6667 16.0007Z" fill="currentColor"/>
    <path d="M22.6666 15.9993C22.6666 12.3175 19.6819 9.33268 16 9.33268C12.3181 9.33268 9.33329 12.3175 9.33329 15.9993C9.33329 19.6812 12.3181 22.666 16 22.666C19.6819 22.666 22.6666 19.6812 22.6666 15.9993ZM25.3333 15.9993C25.3333 21.154 21.1546 25.3327 16 25.3327C10.8453 25.3327 6.66663 21.154 6.66663 15.9993C6.66663 10.8447 10.8453 6.66602 16 6.66602C21.1546 6.66602 25.3333 10.8447 25.3333 15.9993Z" fill="currentColor"/>
    <path d="M17.3333 16C17.3333 15.2636 16.7364 14.6667 16 14.6667C15.2636 14.6667 14.6667 15.2636 14.6667 16C14.6667 16.7364 15.2636 17.3333 16 17.3333C16.7364 17.3333 17.3333 16.7364 17.3333 16ZM20 16C20 18.2091 18.2091 20 16 20C13.7909 20 12 18.2091 12 16C12 13.7909 13.7909 12 16 12C18.2091 12 20 13.7909 20 16Z" fill="currentColor"/>
  </svg>
);

export default CircleRingsIcon;

